
















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDate } from '@/utils/common'
import ModalRemuneracaoSuporteHospital from './ModalRemuneracaoSuporteHospital.vue'
import ModalRemuneracaoSuporteEditarHospital from './ModalRemuneracaoSuporteEditarHospital.vue'
import ModalCadastroGrupoRepasse from './ModalCadastroGrupoRepasse.vue'

@Component({
  components: {
    ModalRemuneracaoSuporteHospital,
    ModalRemuneracaoSuporteEditarHospital,
    ModalCadastroGrupoRepasse,
  },
})
export default class ModalCadastroHospitais extends Vue {
  loadHospitais: boolean = false
  loadAddHospital: boolean = false
  loadEditHospital: string = ''
  loadModalGrupoRepasse: string = ''
  hospitalSearch: string = ''

  get getSuporteHospitaisRemuneracaoStore() {
    return getModule(SuporteHospitaisRemuneracaoStore, this.$store)
  }

  get getHospitais() { return this.getSuporteHospitaisRemuneracaoStore.hospitais }

  get loadingAddHospital() { return this.loadAddHospital }
  set loadingAddHospital(value: boolean) { this.loadAddHospital = value }

  get loadingEditHospital() { return this.loadEditHospital }
  set loadingEditHospital(value: string) { this.loadEditHospital = value }

  get loadingModalGrupoRepasse() { return this.loadModalGrupoRepasse }
  set loadingModalGrupoRepasse(value: string) { this.loadModalGrupoRepasse = value }

  get loadingHospitais() { return this.loadHospitais }
  set loadingHospitais(value: boolean) { this.loadHospitais = value }

  get getHospitaisTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
      { text: 'Nome grupo', class: 'table-headers', align: 'left', value: 'nomeGrupo' },
      { text: 'CNPJ', class: 'table-headers', align: 'left', value: 'cnpj' },
      { text: 'Data início', class: 'table-headers', align: 'left', value: 'inicioUso' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalHospital() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.hospital
  }

  set showModalHospital(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'hospital', value })
  }

  maskCnpj(cnpj: string) {
    return maskCPFCNPJ(cnpj)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async addHospital() {
    this.loadingAddHospital = true
    this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: 'CREATE' })
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value: true })
    this.loadingAddHospital = false
  }

  async editarHospital(item: any) {
    this.loadingEditHospital = item.id
    const request = await this.getSuporteHospitaisRemuneracaoStore.getHospitalById(item.id)
    if (request.success) {
      this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }
    this.loadingEditHospital = ''
  }

  async showModalGrupoRepasse(item: any) {
    this.loadingModalGrupoRepasse = item.id
    this.getSuporteHospitaisRemuneracaoStore.setGrupoHospitalId(item.grupoHospitalId)
    this.getSuporteHospitaisRemuneracaoStore.setHospitalId(item.id)
    const request = await this.getSuporteHospitaisRemuneracaoStore.getGrupoRepasse()
    if (request.success) {
      this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'grupoRepasse', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }
    this.loadingModalGrupoRepasse = ''
  }

  async closeModal() {
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.getSuporteHospitaisRemuneracaoStore.clearHospitaisDetails()
    this.showModalHospital = false
  }
}
